module.exports = __webpack_public_path__ + "static/media/yourwaifu.1334e18d.png";